// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAemn9KmOjtFneuem_HG51Jogg4Epxehhc',
    authDomain: 'aihealthlab.firebaseapp.com',
    databaseURL: 'https://aihealthlab.firebaseio.com',
    projectId: 'aihealthlab',
    storageBucket: 'aihealthlab.appspot.com',
    messagingSenderId: '791392560204',
    appId: '1:791392560204:web:aef82a673abcbd47'
  },
  googleAnalytics: {
    domain: 'none',
    trackingId: 'UA-143399884-1' // replace with your Tracking Id
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
